<template>
  <a-modal title="编辑医生信息" :width="1100" :visible="visible" @cancel="handleCancel">
    <template #footer>
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" :loading="confirmLoading" @click="handleSubmit">保存</a-button>
    </template>
    <a-spin :spinning="confirmLoading">

      <a-tabs
        v-model:activeKey="activeKey"
        tab-position="left"
        @change="changeTab"
      >
      <a-tab-pane :key="1" tab="基本信息">
      <a-form :form="form">

        <a-row :gutter="24">
          <a-col :md="18">
            <a-row :gutter="24">
              <a-col :md="12">
                <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="form.realName" disabled allow-clear placeholder="请输入姓名" />
                </a-form-item>
              </a-col>
              <a-col :md="12">
                <a-form-item label="" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                  <div>
                    <a-switch checked-children="是" un-checked-children="否" v-model="isRecom" /> 名医
                  </div>
                  <!-- <a-input v-model="form.realName" allow-clear placeholder="请输入姓名" /> -->
            
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :md="12">
                <a-form-item label="身份证号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="form.cardNo" disabled allow-clear placeholder="请输入姓名" />
                </a-form-item>
              </a-col>
              <a-col :md="12">
                <a-form-item label="" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                  <a-input v-model="form.mobile" allow-clear placeholder="请输入手机号" />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :md="12">
                <a-form-item label="医院" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="form.organization" disabled allow-clear placeholder="请选择省份" />
                </a-form-item>
              </a-col>
              <a-col :md="12">
                <a-form-item label="" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                  <a-select v-model="form.deptId" placeholder="请选择职位" :options="dept"></a-select>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :md="12">
                <a-form-item label="职称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="form.protitle" disabled allow-clear placeholder="请输入职称" />
                </a-form-item>
              </a-col>
              <a-col :md="12" v-if="form.startTime">
                <a-form-item label="" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                  <a-input v-model="'从业时间：'+''+form.startTime" disabled allow-clear placeholder="请输入时间" />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :md="12">
                <a-form-item label="所在省市" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="form.provinceId" @change="handleChange" placeholder="请选择省份" :options="area">
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="12">
                <a-form-item label="" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                  <a-select v-model="form.cityId" placeholder="请选择市级单位" :options="areaChil"></a-select>
                </a-form-item>
              </a-col>
            </a-row>

          </a-col>
          <a-col :md="6">
            <div class="user_img">
              <img :src="form.photoUrl" alt="" v-show="form.photoUrl != null">
            </div>
            <div class="user_name">
              <div>{{ form.realName}}</div>
              <div>{{ form.sex == 1? '男' : '女'}}</div>
              <div>{{ form.age}}岁</div>
            </div>
            <div class="user_position">
              <div>
                {{ form.protitle}}
              </div>
              <div>
                <!-- <span>100人关注</span> -->
              </div>
            </div>
          </a-col>

        </a-row>

        <a-row :gutter="24">
          <a-col :md="24" style="padding-left:3px">
            <a-form-item label="擅长" :labelCol="{xs: { span: 24 },sm: { span: 2 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 22 }}">
              <a-textarea v-model="form.expertIn" showCount :rows="2" placeholder="请输入擅长" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :md="24" style="padding-left:3px">
            <a-form-item label="简介" :labelCol="{xs: { span: 24 },sm: { span: 2 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 22 }}">
              <a-textarea v-model="form.drInfo" showCount :rows="6" placeholder="请输入简介" />
            </a-form-item>
          </a-col>
        </a-row>

      </a-form>
    </a-tab-pane>
    <a-tab-pane :key="2" tab="医生资质">
      <a-form :form="form">

        <a-row :gutter="24">
          <a-col :md="24">
            <a-row :gutter="24">
              <a-col :md="16">
                <a-form-item label="执业证书编号：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="formQuality.practisingCertCode" allow-clear placeholder="请输入执业证书编号" style="width: 300px;"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="16">
                <a-form-item label="执业类别：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="formQuality.practisingTypeCode" placeholder="请选择执业类别" :options="PractisingTypeCodeList" show-search       :filter-option="filterOption1"></a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="16">
                <a-form-item label="执业范围：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="formQuality.practisingScopeCode" placeholder="请选择执业范围" :options="PractisingScopeCodeList" show-search       :filter-option="filterOption2">
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="16">
                <a-form-item label="职称资格证编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="formQuality.drNvqNo" allow-clear placeholder="请输入职称资格证编号" style="width: 300px;"/>
                </a-form-item>
              </a-col>
            </a-row>
              <!-- 上传图片 -->
              <upload-Img  :selectFrom="getSelect" @addSelect="fn_getSelect" />

          </a-col>
        </a-row>


     </a-form>

    </a-tab-pane>
            
    </a-tabs>

  
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { baDoctorEdit, baDoctorQuery, baDoctorQueryDept, baDoctorQueryArea, doctorEditQuality, getDoctordetail, getbaDatadictDetailList } from '@/api/modular/interhospital/badoctor/baDoctorManage'
  import uploadImg from '../picture/components/uploadImg.vue'

  export default {
    components: {
      uploadImg,
    },
      data () {
        return {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 5 }
          },
          labelCol_two: {
            xs: { span: 24 },
            sm: { span: 1 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 19 }
          },
          birthdayDateString: '',
          ctstampDateString: '',
          visible: false,
          confirmLoading: false,
          form: {},
          isRecom: false,
          dept: [],
          area: [],
          areaChil: [],
          activeKey: 1,
          formQuality: {},
          PractisingTypeCodeList: [], // 执业类别字典
          PractisingScopeCodeList: [], // 执业范围字典
          file: null,
          getSelect: {}

        }
    },
    methods: {
      moment,
      fn_getSelect(getValue) {
        console.log( '获取组件值',getValue)
        this.getSelect = getValue;
        this.formQuality.idcardImg1 = this.getSelect.imageUrl1;
        this.formQuality.idcardImg2 = this.getSelect.imageUrl2;
        if(this.getSelect.imageUrl3 && this.getSelect.imageUrl4){
          this.formQuality.doctorImg1 = this.getSelect.imageUrl3 + '|' + this.getSelect.imageUrl4;
        }else{
          if(this.getSelect.imageUrl3){
            this.formQuality.doctorImg1 = this.getSelect.imageUrl3;
          }else if(this.getSelect.imageUrl4){
            this.formQuality.doctorImg1 = this.getSelect.imageUrl4;
          }else{
            this.formQuality.doctorImg1 = ''
          }
        }
        if(this.getSelect.imageUrl5 && this.getSelect.imageUrl6){
          this.formQuality.doctorImg2 = this.getSelect.imageUrl5 + '|' + this.getSelect.imageUrl6;
        }else{
          if(this.getSelect.imageUrl5){
            this.formQuality.doctorImg2 = this.getSelect.imageUrl5;
          }else if(this.getSelect.imageUrl6){
            this.formQuality.doctorImg2 = this.getSelect.imageUrl6;
          }else{
            this.formQuality.doctorImg2 = ''
          }
        }
        console.log( '获取组件值传给接口',this.formQuality)
      },
      
      changeTab(e) {
        this.activeKey = e
        if(this.activeKey == 2){
          // this.getDoctorQuality(this.form.userId);
          // this.getPractisingTypeCode();
          // this.getPractisingScopeCode();

        }
      },
      // 初始化方法
      edit (record) {
        this.visible = true;
        this.getDept(record.orgId);
        this.getBaDoctor(record.userId);
        this.getArea();
        this.getDoctorQuality(record.userId);
        this.getPractisingTypeCode();
        this.getPractisingScopeCode();
      },

      // 获取医生信息
      getBaDoctor(userId) {
        let parasm = {
          userId,
        }
        baDoctorQuery(parasm).then(res => {
          if (res.code == 200) {
            this.form = res.data;
            this.form.cardNo = this.form.cardNo.replace(/(\w{6})\w*(\w{4})/, '$1********$2')
            this.isRecom = this.form.isRecom == 1 ? true : false;
            this.getAreaChil(res.data.provinceId)
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 获取医生资质信息
      getDoctorQuality(userId) {
        let parasm = {
          userId,
        }
        getDoctordetail(parasm).then(res => {
          if (res.code == 200) {
            const {idcardImg1, idcardImg2, doctorImg1, doctorImg2} = res.data;
            this.formQuality = res.data;
            this.getSelect = {
              imageUrl1: idcardImg1,
              imageUrl2: idcardImg2,
              imageUrl3: doctorImg1 ? doctorImg1.split('|')[0] : '',
              imageUrl4: doctorImg1 ? doctorImg1.split('|')[1] : '',
              imageUrl5: doctorImg2 ? doctorImg2.split('|')[0] : '',
              imageUrl6: doctorImg2 ? doctorImg2.split('|')[1] : '',
            }
            console.log('页面加载显示',this.formQuality)
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 获取科室信息
      getDept(orgId) {
        let parasm = {
          orgId,
        }
        baDoctorQueryDept(parasm).then(res => {
          if (res.code == 200) {
            // this.form = res.data;
            this.dept = [];
            res.data.map(item => {
              this.dept.push({
                value: item.deptId,
                label: item.deptName,
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 获取省会
      getArea() {
        let parasm = {
          parentId: '', 
        }
        baDoctorQueryArea(parasm).then(res => {
          if (res.code == 200) {
            this.area = [];
            res.data.map(item => {
              this.area.push({
                value: item.areaId,
                label: item.areaName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 获取市级
      getAreaChil(parentId) {
        let parasm = {
          parentId,
        }
        baDoctorQueryArea(parasm).then(res => {
          if (res.code == 200) {
            this.areaChil = [];
            res.data.map(item => {
              this.areaChil.push({
                value: item.areaId,
                label: item.areaName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 编辑医生信息
      handleSubmit () {
        this.confirmLoading = true;
        if(this.activeKey == 1){
          let params = {
            userId: this.form.userId,
            expertIn: this.form.expertIn,
            sex: this.form.sex,
            deptId: this.form.deptId,
            mobile: this.form.mobile,
            provinceId: this.form.provinceId,
            cityId: this.form.cityId,
            drInfo: this.form.drInfo,
            isRecom: this.isRecom ? 1 : 0
          }
          baDoctorEdit(params).then((res) => {
            if (res.code == 200) {
              this.$message.success('编辑成功')
              this.confirmLoading = false;
              this.handleCancel();
              this.$emit('ok')
              
            } else {
              this.confirmLoading = false
              this.$message.error('编辑失败')//  + res.message
            }
          })
        }else{
          console.log('params传给接口的值1111111111',this.formQuality)
          let params = {
            userId: this.form.userId,
            drNvqNo: this.formQuality.drNvqNo,
            practisingCertCode: this.formQuality.practisingCertCode,
            practisingTypeCode: this.formQuality.practisingTypeCode,
            practisingScopeCode: this.formQuality.practisingScopeCode,
            idcardImg1: this.formQuality.idcardImg1,
            idcardImg2: this.formQuality.idcardImg2,
            doctorImg1: this.formQuality.doctorImg1 ? this.formQuality.doctorImg1 : '',
            doctorImg2: this.formQuality.doctorImg2 ? this.formQuality.doctorImg2 : ''
          }
          console.log('params传给接口的值',params)
          doctorEditQuality(params).then((res) => {
            if (res.code == 200) {
              this.$message.success('编辑成功')
              this.confirmLoading = false;
              this.handleCancel();
              this.$emit('ok')
              
            } else {
              this.confirmLoading = false
              this.$message.error('编辑失败')//  + res.message
            }
          })
        }
      
      
      },
      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      handleCancel () {
        this.visible = false;
        this.activeKey = 1;
      },
      handleChange(ev) {
        this.form.cityId = ''
        this.getAreaChil(ev)
      },
   // 医师执业类别
      getPractisingTypeCode() {
        let parasm = {
          dictId: 8
        }
        getbaDatadictDetailList(parasm).then(res => {
          if (res.code == 200) {
            this.PractisingTypeCodeList = [];
            res.data.map(item => {
              this.PractisingTypeCodeList.push({
                value: item.detailValue,
                label: item.detailName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 医师执业范围
      getPractisingScopeCode() {
        let parasm = {
          dictId: 9
        }
        getbaDatadictDetailList(parasm).then(res => {
          if (res.code == 200) {
            this.PractisingScopeCodeList = [];
            res.data.map(item => {
              this.PractisingScopeCodeList.push({
                value: item.detailValue,
                label: item.detailName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      filterOption1(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption2(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      
    }
  }
</script>
<style lang="less" scoped>
/deep/ .ant-upload-list{
  // display: none; //隐藏医生资质的缩略图
}
.ant-tabs-bar {
    padding: 16px 0px 0px 16px;
}

.user_img{
  background-color: #ccc;
  width: 180px;
  height: 200px;
  &>img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
.user_name{
  display: flex;
  margin-top: 20px;
  &>div{
    flex: 1;
    height: 20px;
    line-height: 20px;
    font-weight: bold;
  }
  &>div:first-child{
    font-size: 18px;
    flex: 2;
  }
  &>div:nth-child(2){
    text-align: center;
  }

}
.user_position{
  margin-top: 20px;
  display: flex;
  font-size: 16px;
  &>div{
    font-weight: bold;
    flex: 1;
    text-align: center;
    line-height: 30px;
    height: 30px;
  }
  &>div:last-child{
    &>span{
      margin-top: 5px;
      padding: 0 5px;
      height: 20px;
      border: 1px solid red;
      font-size: 13px;
      color: red;
      border-radius: 15px;
      line-height: 20px;
      font-weight: normal;
    }
  }
}

.avatar-uploader1{
  display: inline-block;
  width: 150px;
}
.avatar-uploader2{
  display: inline-block;
  width: 150px;
}

.getImg{
  position: relative;
  display: inline-block;
  .del{
    width: 14px;
    height: 14px;
    border-radius: 14px;
    background: red;
    color: #fff;
    position: absolute;
    right: -5px;
    top: -5px;
    display: inline-block;
    line-height: 10px;
    text-align: center;
    font-size: 12px;
    text-align: center;
    cursor: pointer;

  }
  .doctordel{
    right: 50px;
  }
}
/deep/ .ant-upload-list-picture-card-container{
 margin-right: 50px;
}
/deep/ .ant-form-item-children {
    position: relative;
    display: flex;
}
</style>